import type { DaysLocale } from "@/locales/fr/days";

const daysLocale: DaysLocale = {
  days: {
    monday: "Monday",
    tuesday: "Tuesday",
    wednesday: "Wednesday",
    thursday: "Thursday",
    friday: "Friday",
    saturday: "Saturday",
    sunday: "Sunday",
  },
};

export default daysLocale;
